module.exports = __webpack_public_path__ + "img/tank.08a86798.jpg";